import * as v from "valibot";
import { rpcContract } from "../rpc";

/**
 * Get creator's own subscription tier
 * Returns null if tier doesn't exist yet
 */
export const getMySubscriptionTierRpcContract = rpcContract({
  name: "get-my-subscription-tier",
  paramsSchema: v.object({}),
  resultSchema: v.object({
    tier: v.nullable(
      v.object({
        id: v.string(),
        stripeProductId: v.string(),
        stripePriceId: v.string(),
        name: v.string(),
        description: v.nullable(v.string()),
        monthlyPriceCents: v.number(),
        active: v.boolean(),
        createdAt: v.string(),
      }),
    ),
  }),
});

export type GetMySubscriptionTierParams = v.InferOutput<(typeof getMySubscriptionTierRpcContract)["paramsSchema"]>;
export type GetMySubscriptionTierResult = v.InferOutput<(typeof getMySubscriptionTierRpcContract)["resultSchema"]>;
